export default {"src":"/_next/static/media/list.7c835b6e.svg","height":512,"width":512};